export const faqs = [
    {
        id: 1,
        question: "Što je Osječko loyalty aplikacija?",
        answer:
            "Za naše najvjernije potrošače pripremili smo vrlo zanimljive nagrade. Ispod čepova Osječkog piva 0,33l/0,5l i Osječkog Crnog radlera 0,5l nalaze se kodovi. Svaki kod je jedan bod više do nagrada. Najuporniji dobivaju najviše. Beeraj s razlogom!",
    },
    {
        id: 2,
        question: "Kako se skupljaju bodovi i mijenjaju za nagrade?",
        answer: (
            <div>
                <p>
                    <strong>1. korak:</strong> kupi staklenu bocu Osječkog piva 0,33l/0,5l
                    ili Osječkog Crnog radlera 0,5l
                </p>
                <p>
                    <strong>2. korak:</strong> ispod čepa Osječkog piva ili Osječkog Crnog
                    radlera pronađi kod
                </p>
                <p>
                    <strong>3. korak:</strong> putem mobilnog uređaja prijavi se u web
                    aplikaciju i upiši kod
                </p>
                <p>
                    <strong>4. korak:</strong> provjeri svoje sakupljene bodove i zamijeni
                    ih za nagrade
                </p>
            </div>
        ),
    },
    {
        id: 3,
        question:
            "Kad sam siguran/a da sam registriran/a i da mogu početi skupljati bodove?",
        answer:
            "Kad se registriraš i prijaviš putem web aplikacije (nakon potvrde e-maila), možeš početi sakupljati bodove i mijenjati ih za nagrade.",
    },
    {
        id: 4,
        question: "Kako funkcionira dostava nagrada?",
        answer: (
            <div>
                <p>
                    Skoro sve nagrade, osim nagrada koje ne stanu u paketomate,
                    dostavljaju se putem paketomata Hrvatske pošte.
                </p>
                <p>
                    Prilikom zamjene bodova za nagradu imate opciju izabrati na karti sebi
                    najbliži paketomat.
                </p>
                <p>
                    Nakon što odaberete paketomat i zamijenite bodove, paket će biti
                    dostavljen u roku od 3 do 5 radnih dana i o tome ćete biti na vrijeme
                    obaviješteni.
                </p>
                <p>
                    Nagrade koje ne stanu u paketomate dobit ćete na adresu iz korisničkog
                    profila putem dostavljača.
                </p>
            </div>
        ),
    },
    {
        id: 5,
        question: "Blokiran ti je profil?",
        answer: (
            <div>
                <p>
                    Ako si zbog lošije vidljivosti svih znamenki koda na čepu previše puta pogrešno unio/jela kod te ti
                    je zbog toga blokiran profil, javi se na <a className="text-14p text-tel font-bold font-inter cursor-pointer" href="mailto:info@easy-going.hr">info@easy-going.hr</a> e-mailom s kojeg si se registrirao/la i
                    mi ćemo te odblokirati.
                </p>
            </div>
        ),
    },
];

export const faqReg = [
    {
        id: 1,
        question: "Što su personalizirane ponude i promocije?",
        answer:
            "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, 'Lorem ipsum dolor sit amet..', comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.",
    },
    {
        id: 2,
        question: "Što su personalizirane ponude i promocije?",
        answer:
            "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
    },
    {
        id: 3,
        question: "Što su personalizirane ponude i promocije?",
        answer:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
];
